"use client";

import React, { useEffect, useState } from "react";
import "./style.css";
import {
  getUpgradeSubscriptionInvoice,
  upgradeSubscriptionToYearly,
} from "../../../components/https/planSubscriptions";
import { errorRequestHandel } from "../../../helper";
import { Col, Row, Spin, Typography, Card, Button, message } from "antd";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";

const { Title, Text } = Typography;

const UpgradePanModal = ({ onClose, onRefetch }) => {
  const [information, setInformation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchUpgradeSubscriptionInvoice();
  }, []);

  const fetchUpgradeSubscriptionInvoice = async () => {
    try {
      setLoading(true);
      const response = await getUpgradeSubscriptionInvoice();
      if (response.status === 200) {
        setInformation(response.data?.data);
      }
    } catch (error) {
      errorRequestHandel({ error });
    } finally {
      setLoading(false);
    }
  };

  const onHandleUpgradePlan = async () => {
    try {
      setIsLoading(true);
      const response = await upgradeSubscriptionToYearly();
      if (response.status === 200) {
        message.success("Your subscription has been successfully upgraded.");
        onRefetch();
        setIsLoading(false);
        onClose();
      }
    } catch (error) {
      setIsLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  if (loading) {
    return (
      <div
        className="flex items-center justify-center p-10"
        style={{ height: 250 }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!information) {
    return null; // or show placeholder
  }

  const { total_to_be_paid, currency, total, unit_price, quantity } =
    information;

  const monthlyAmount = (total / 100 / 12).toFixed(2); // $83.33/month
  const nextCycleAmount = (total / 100).toFixed(2);

  const formatAmount = (amountInCents) => `${(amountInCents / 100).toFixed(2)}`;

  const handleOnContactUs = () => {
    const url = "https://dentalid.app/contact-us.html";
    window.open(url, "_blank"); // open in new tab
  };

  return (
    <div className="upgrade_plan_container">
      <div className="upgrade_plan_body">
        <div className="_header">
          <div className="_img">
            <img src={dentalIcons?.upgradeSubscription} />
          </div>
          <h4>Upgrade Subscription</h4>
        </div>
        <div className="upgrade_plans_section">
          <div className="plan_left">
            <h3>Yearly Subscription</h3>
            <div className="plan_left_current">
              <h1>${formatAmount(unit_price)}</h1>{" "}
              <div className="plan_left_current_month">
                <p>Per Seat / Year</p>
                {/* <p style={{ paddingBottom: 5 }}>Month</p> */}
              </div>
            </div>
            <div>
              <strong>${nextCycleAmount} billed yearly</strong>
            </div>
            <div className="plan_belling_info">
              <div className="info_item">
                <div className="_dot">
                  <div className="dot" />
                </div>
                <p>
                  You will pay{" "}
                  <strong>${formatAmount(total_to_be_paid)}</strong> today
                  (monthly credit applied).
                </p>
              </div>
              <div className="info_item">
                <div className="_dot">
                  <div className="dot" />
                </div>
                <div>
                  <p>
                    Next year’s renewal will be{" "}
                    <strong>${formatAmount(total)}</strong>.
                  </p>
                </div>
              </div>
            </div>
            <br />
            <CustomPrimaryButton
              title="Upgrade"
              width={"100%"}
              isLoading={isLoading}
              onClick={onHandleUpgradePlan}
            />
          </div>
          <div className="plan_right">
            <div>
              <h3>Dental ID Enterprise</h3>
              <>
                <p
                  style={{
                    marginTop: "8px",
                  }}
                >
                  A tailored solution for teams that require advanced
                  capabilities and full platform access.
                  <strong> Dental ID Enterprise includes:</strong>
                </p>

                <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
                  <li style={{ fontSize: "12px" }}>On-premise deployment</li>
                  <li style={{ fontSize: "12px" }}>Unlimited projects</li>
                  <li style={{ fontSize: "12px" }}>300 AI credits</li>
                  <li style={{ fontSize: "12px" }}>
                    Dedicated onboarding and support
                  </li>
                </ul>

                <p style={{ marginTop: "8px", color: "#545050" }}>
                  Perfect for high-volume use cases or security-sensitive
                  environments.
                </p>
              </>
            </div>
            <div>
              <CustomPrimaryButton
                title="Contact Us"
                width={"100%"}
                onClick={handleOnContactUs}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePanModal;
